import React from 'react';

import { Typography } from '@material-ui/core';

import { useForm } from 'react-hook-form';

import Logo from '../../components/logo/logo';
import { AppContext } from '../../_context';

import { appStyles } from '../../_styles';
import { AmFormButton } from '../../controls';

const Home = () => {
  const classes = appStyles();

  const { handleSubmit } = useForm();

  return (
    <div>
      <Logo></Logo>
      <AppContext.Consumer>
        {({ user, logoutUser }) => (
          <div>
            <Typography variant="h4" component="h1" color="textSecondary">
              Welcome Home!!!
              {user?.name}
            </Typography>
            <form className={classes.form} onSubmit={handleSubmit(logoutUser)}>
              <AmFormButton>Sign Out</AmFormButton>
            </form>
          </div>
        )}
      </AppContext.Consumer>
    </div>
  );
};

export { Home };
